import { useMutation } from '@tanstack/react-query';
import type { IPatchPlaidAccountParams } from 'api/resources/plaidAccounts';
import { patchPlaidAccount } from 'api/resources/plaidAccounts';

export const usePatchPlaidAccount = () => {
	return useMutation((params: IPatchPlaidAccountParams) =>
		patchPlaidAccount(params)
	);
};
